'use strict';

var getExtendedDate = require('./getExtendedDate');

function createDateWithContext(contextDate, d, options, forceClone) {
  return getExtendedDate(contextDate, d, options, forceClone).date;
}

module.exports = createDateWithContext;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/createDateWithContext.js
// module id = 516
// module chunks = 0